import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { useServicesContent } from "@/hooks/useServicesContent";
import { Skeleton } from "@/components/ui/skeleton";
import { openGoogleCalendar } from "@/lib/utils";

export function ServicesCTA() {
  const { content, loading } = useServicesContent("cta");
  const ctaData = content[0]?.content_value;

  if (loading) {
    return (
      <section className="py-16 bg-brand-primary text-white">
        <div className="container mx-auto px-6 text-center space-y-4">
          <Skeleton className="h-10 w-96 mx-auto bg-white/20" />
          <Skeleton className="h-6 w-[500px] mx-auto bg-white/20" />
          <Skeleton className="h-12 w-48 mx-auto bg-white/20" />
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-brand-primary text-white">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold  mb-4">
          {ctaData?.title || "Pronto para Começar sua Jornada?"}
        </h2>
        <p className="text-xl  mb-8">
          {ctaData?.subtitle || "Escolha o serviço ideal para você e agende sua consulta"}
        </p>
        <Button 
          size="lg" 
          className="bg-white text-brand-primary hover:bg-gray-50 font-accent"
          onClick={openGoogleCalendar}
        >
          <Calendar className="w-5 h-5 mr-2" />
          {ctaData?.buttonText || "Agendar Agora"}
        </Button>
      </div>
    </section>
  );
}
